__turbopack_context__.v({
  "content": "pf6nVW_content",
  "contentWrapper": "pf6nVW_contentWrapper",
  "shadow": "pf6nVW_shadow",
  "sideWrapper": "pf6nVW_sideWrapper",
  "sideWrapperInner": "pf6nVW_sideWrapperInner",
  "sideWrapperInnerLeft": "pf6nVW_sideWrapperInnerLeft",
  "sideWrapperInnerRight": "pf6nVW_sideWrapperInnerRight",
  "sideWrapperLeft": "pf6nVW_sideWrapperLeft",
  "sideWrapperRight": "pf6nVW_sideWrapperRight",
  "svgDots": "pf6nVW_svgDots",
  "svgDotsLeft": "pf6nVW_svgDotsLeft",
  "svgDotsRight": "pf6nVW_svgDotsRight",
  "wrapper": "pf6nVW_wrapper",
});
